// Helpers purs de la page « Alarmes » (back_api : GET /alarms, GET /alarm,
// PUT /alarm-note, POST /alarm-mute|alarm-unmute|alarm-rerun).
// Testés sans navigateur : node --test src/helpers/alarms.test.mjs

export const MUTE_DURATIONS = [
    { hours: 6, label: "6 h" },
    { hours: 24, label: "24 h" },
    { hours: 72, label: "3 jours" },
    { hours: 168, label: "1 semaine" },
];

export const ERROR_WINDOWS = [
    { hours: 6, label: "6 h" },
    { hours: 24, label: "24 h" },
    { hours: 72, label: "3 j" },
    { hours: 168, label: "7 j" },
];

export const ALARM_VIEWS = [
    { value: "alert", label: "En alerte" },
    { value: "muted", label: "En sourdine" },
    { value: "all", label: "Toutes" },
];

export function stateLabel(state) {
    switch (state) {
        case "ALARM":
            return "En alerte";
        case "OK":
            return "OK";
        case "INSUFFICIENT_DATA":
            return "Sans données";
        default:
            return state || "—";
    }
}

export function stateColor(state) {
    switch (state) {
        case "ALARM":
            return "danger";
        case "OK":
            return "success";
        default:
            return "secondary";
    }
}

// Notifications coupées : par pikachu (mutedUntil) ou hors pikachu.
export function isMuted(alarm) {
    return !!alarm && alarm.actionsEnabled === false;
}

export function filterAlarms(list, view, query) {
    const q = String(query || "").trim().toLowerCase();
    return (Array.isArray(list) ? list : []).filter((a) => {
        if (view === "alert" && a.state !== "ALARM") return false;
        if (view === "muted" && !isMuted(a)) return false;
        if (q === "") return true;
        return [a.name, a.function, a.family, a.note].some((v) => String(v || "").toLowerCase().includes(q));
    });
}

// Regroupe par famille ; les familles qui ont le plus d'alarmes en alerte d'abord.
export function groupByFamily(list) {
    const groups = new Map();
    (Array.isArray(list) ? list : []).forEach((a) => {
        const family = a.family || "Autres robots";
        if (!groups.has(family)) groups.set(family, []);
        groups.get(family).push(a);
    });
    const alerting = (alarms) => alarms.filter((a) => a.state === "ALARM").length;
    return Array.from(groups.entries())
        .map(([family, alarms]) => ({ family, alarms }))
        .sort((x, y) => alerting(y.alarms) - alerting(x.alarms) || y.alarms.length - x.alarms.length || x.family.localeCompare(y.family));
}

export function countByState(list) {
    const out = { ALARM: 0, OK: 0, INSUFFICIENT_DATA: 0, muted: 0 };
    (Array.isArray(list) ? list : []).forEach((a) => {
        if (out[a.state] !== undefined) out[a.state] += 1;
        if (isMuted(a)) out.muted += 1;
    });
    return out;
}

// « depuis 3 h », « depuis 2 j » (null/invalide → "").
export function since(value, now = new Date()) {
    const t = new Date(value);
    if (!value || isNaN(t.getTime()) || t.getFullYear() < 1971) return "";
    const minutes = Math.max(0, Math.round((now.getTime() - t.getTime()) / 60000));
    if (minutes < 60) return "depuis " + minutes + " min";
    const hours = Math.round(minutes / 60);
    if (hours < 48) return "depuis " + hours + " h";
    return "depuis " + Math.round(hours / 24) + " j";
}
